import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { EventService } from 'src/app/services/event.service';
import endpoints from 'src/app/helpers/endpoints';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fury-file-claim-status-change-modal',
  templateUrl: './file-claim-status-change-modal.component.html',
  styleUrls: ['./file-claim-status-change-modal.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class FileClaimStatusChangeModalComponent implements OnInit, OnDestroy {

  statusChangeForm!: FormGroup;
  status: any[] = [];
  agentId = null;
  ngUnsubscribe = new Subject<void>();
  constructor( private apiservice: ApiService,
    private storage: StorageService,
    public dialogRef: MatDialogRef<FileClaimStatusChangeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService,
  ) {
     
     }

  ngOnInit(): void {
    this.agentId = this.storage.getUser()?.userId;
    this.statusChangeForm = new FormGroup({
      status: new FormControl(this.data?.status, [Validators.required]),
      note: new FormControl('', [Validators.required])
    });
    this.eventService.getClaimStatus$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((status: any[])=>{
      this.status = status;
    })
  }
  changeStatus(){
    if(this.statusChangeForm.invalid) {
      this.statusChangeForm.markAllAsTouched();
      return;
    }
    if(this.data?.mode ==='multiple'){
      this.multipleStatusChange();
    }
    else{
      this.singleStatusChange();
    }
  };

  singleStatusChange(){
    const payload = {status : this.statusChangeForm.value?.status, agentId : this.agentId, note: this.statusChangeForm.value?.note};
    this.apiservice.patch(endpoints.customerDashboard.changeClaimStatus(this.data?.fileClaimId),payload).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res){
        this.apiservice.alert(res.body?.message, ErrorType.Success);
        this.dialogRef.close(this.statusChangeForm.value?.status);
      }
    }, (err: HttpErrorResponse)=>{
      this.apiservice.alert(err.message, ErrorType.Error);
    })
  }

  multipleStatusChange(){
    const payload = {claimIds : this.data?.fileClaimIds, status : this.statusChangeForm.value?.status, agentId : this.agentId, note: this.statusChangeForm.value?.note};
    this.apiservice.patch(endpoints.fileAClaim.changeMultipleStatus,payload).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res){
        this.apiservice.alert(res.body?.message, ErrorType.Success);
        this.dialogRef.close(this.statusChangeForm.value?.status);
      }
    }, (err: HttpErrorResponse)=>{
      this.apiservice.alert(err.message, ErrorType.Error);
    })
  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(){
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
